var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 21.7732C12.8132 21.7732 10.2266 19.1866 10.2266 15.9999C10.2266 12.8132 12.8132 10.2266 15.9999 10.2266C19.1866 10.2266 21.7732 12.8132 21.7732 15.9999C21.7732 19.1866 19.1866 21.7732 15.9999 21.7732ZM15.9999 12.2266C13.9199 12.2266 12.2266 13.9199 12.2266 15.9999C12.2266 18.0799 13.9199 19.7732 15.9999 19.7732C18.0799 19.7732 19.7732 18.0799 19.7732 15.9999C19.7732 13.9199 18.0799 12.2266 15.9999 12.2266Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 28.0265C10.9871 28.0265 6.25376 25.0931 3.00043 19.9998C1.5871 17.7998 1.5871 14.2131 3.00043 11.9998C6.2671 6.90648 11.0004 3.97314 16.0004 3.97314C21.0004 3.97314 25.7338 6.90648 28.9871 11.9998C30.4004 14.1998 30.4004 17.7865 28.9871 19.9998C25.7338 25.0931 21.0004 28.0265 16.0004 28.0265ZM16.0004 5.97314C11.6938 5.97314 7.57376 8.55981 4.69376 13.0798C3.69376 14.6398 3.69376 17.3598 4.69376 18.9198C7.57376 23.4398 11.6938 26.0265 16.0004 26.0265C20.3071 26.0265 24.4271 23.4398 27.3071 18.9198C28.3071 17.3598 28.3071 14.6398 27.3071 13.0798C24.4271 8.55981 20.3071 5.97314 16.0004 5.97314Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.46f0cc3e398cb350d2afffc3cdef43fa.svg";
export { ForwardRef as ReactComponent };